var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagstageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508.59 111.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #fcc933;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1",
    "data-name": "Lag 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m296.49,69.53c-3.36,0-5.71-.69-7.05-2.06-1.33-1.38-2-3.86-2-7.45v-29.74h15.23v-13.17h-15.23V0h-13.18v59.79c0,7.56,1.74,12.97,5.22,16.21,3.47,3.25,8.57,4.87,15.29,4.87h8.02v-11.34h-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.13,67.78c-10.23,0-18.52-8.29-18.52-18.52s8.29-18.52,18.52-18.52,18.52,8.29,18.52,18.52-8.29,18.52-18.52,18.52m31.58-18.52c0-17.44-14.14-31.58-31.58-31.58s-31.58,14.14-31.58,31.58,14.14,31.58,31.58,31.58c6.92,0,13.32-2.23,18.52-6.01v6.05h13.06v-31.52h0s0-.06,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m339.66,67.81c-10.23,0-18.52-8.29-18.52-18.52s8.29-18.52,18.52-18.52,18.52,8.29,18.52,18.52h0c0,10.23-8.29,18.52-18.52,18.52m31.58-18.52h0v-.43h0c-.23-17.24-14.27-31.15-31.57-31.15s-31.58,14.14-31.58,31.58,14.14,31.58,31.58,31.58c6.92,0,13.32-2.23,18.52-6.01v6.05h13.06v-31.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m459.12,44.6c.15-.6.34-1.19.56-1.77,2.64-7.01,9.4-12,17.34-12s14.7,4.99,17.34,12c.21.58.4,1.17.56,1.77h-35.79Zm49.12,9.51c.23-1.55.35-3.14.35-4.76s-.12-3.21-.36-4.75c-.09-.6-.2-1.19-.32-1.77-3-14.31-15.69-25.05-30.9-25.05-17.44,0-31.58,14.13-31.58,31.57s14.14,31.58,31.58,31.58c12,0,22.43-6.69,27.77-16.54.62-1.14,1.16-2.31,1.64-3.52h-14.91c-1.06,1.34-2.29,2.52-3.68,3.52-3.04,2.19-6.78,3.49-10.82,3.49s-7.78-1.3-10.82-3.49c-1.38-1-2.62-2.19-3.68-3.52-1.18-1.49-2.15-3.17-2.84-4.98,0-.02-.01-.04-.02-.06-.21-.56-.39-1.13-.54-1.71h49.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.58,67.79c-10.23,0-18.52-8.29-18.52-18.52h0c0-10.24,8.3-18.52,18.52-18.52s18.52,8.29,18.52,18.52-8.29,18.52-18.52,18.52m0-50.1c-6.92,0-13.32,2.23-18.52,6.01V.02H0v49.26c0,17.44,14.14,31.58,31.58,31.58s31.58-14.14,31.58-31.58-14.14-31.58-31.58-31.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m439.91,49.43h0v-.39h0c-.21-17.26-14.26-31.19-31.57-31.19s-31.58,14.14-31.58,31.58,14.14,31.58,31.58,31.58h12.05v-13.06h-12.05c-10.23,0-18.52-8.29-18.52-18.52s8.29-18.52,18.52-18.52,18.49,8.26,18.52,18.46v32.3c0,6.11-1.68,10.77-5.04,13.97-3.36,3.21-7.64,4.81-12.83,4.81-4.74,0-8.63-1.05-11.68-3.15-3.06-2.1-5.12-5.02-6.19-8.76h-12.94c1.37,7.18,4.79,12.87,10.25,17.07,5.46,4.2,12.62,6.3,21.48,6.3,6.19,0,11.53-1.3,16.04-3.89,4.51-2.6,7.96-6.17,10.37-10.71,2.41-4.54,3.61-9.75,3.61-15.64v-32.24h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 170.89,
    y: 67.95,
    width: 13.43,
    height: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.77,49.04c-.21-17.26-14.26-31.19-31.57-31.19s-30.65,13.23-31.53,29.88h13.09c.86-9.43,8.79-16.83,18.44-16.83,10.21,0,18.49,8.26,18.52,18.46v32.3c0,6.11-1.68,10.77-5.04,13.97-3.36,3.21-7.64,4.81-12.83,4.81-4.74,0-8.63-1.05-11.68-3.15-3.06-2.1-5.12-5.02-6.19-8.76h-12.94c1.37,7.18,4.79,12.87,10.25,17.07,5.46,4.2,12.62,6.3,21.48,6.3,6.19,0,11.53-1.3,16.04-3.89,4.51-2.6,7.96-6.17,10.37-10.71,2.41-4.55,3.61-9.76,3.61-15.64v-32.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.36,63.67l-9.26,9.26c5.2,4.67,11.95,7.65,19.4,8.04v-13.09c-3.84-.35-7.34-1.87-10.14-4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.96,61.27c-2.33-2.8-3.86-6.3-4.21-10.14h-13.09c.39,7.44,3.37,14.2,8.04,19.4l9.26-9.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 255.47,
    y: 17.11,
    width: 13.43,
    height: 13.17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "234.6 80.87 234.6 67.7 231.42 67.7 220.86 67.7 220.86 80.87 234.6 80.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.67,42.41h-11.67v13.17h11.67c.76,0,1.49.15,2.16.4l8.98-10.01c-3.14-2.24-6.98-3.56-11.14-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.96,55.58h8.64v-13.17h-8.64c-3.35,0-6.06-2.72-6.06-6.06s2.71-6.07,6.06-6.07h26.05v-13.17h-26.05c-8.5,0-15.71,5.52-18.25,13.17-.64,1.91-.98,3.95-.98,6.07s.34,4.16.98,6.06c2.53,7.65,9.75,13.17,18.25,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.55,67.63c-.29.04-.58.07-.88.07h-11.67v13.17h11.67c2.71,0,5.28-.56,7.62-1.57l-6.74-11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m267.92,55.58c-.93-2.81-2.5-5.33-4.53-7.4l-8.85,9.87c.74,1.01,1.19,2.25,1.19,3.6,0,1.82-.81,3.45-2.08,4.56l6.62,11.47c3.55-2.35,6.28-5.85,7.65-9.97.64-1.9.98-3.94.98-6.06s-.34-4.16-.98-6.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "217.46 80.87 217.46 67.7 212.58 67.7 204.3 67.7 204.3 80.87 212.58 80.87 212.58 80.87 217.46 80.87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagstageLogo);
export default __webpack_public_path__ + "static/media/bagstage-logo.4cbad7b0e8d450e4cab3efbd56580c8a.svg";
export { ForwardRef as ReactComponent };